import React, { useState, useEffect, useRef } from "react";
import { Bell } from "react-feather";
import axios from "axios";
import "../styles/Dashboard.css";

// Base API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://depotaircerdas.com/api";

const Notification = ({ username }) => {
    const [notifications, setNotifications] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const dropdownRef = useRef(null);

    // **Ambil Token dari Local Storage**
    const getToken = () => {
        const token = localStorage.getItem("token");
        return token ? `Bearer ${token}` : null;
    };

    // **Fetch Notifikasi**
    useEffect(() => {
        const fetchNotifications = async () => {
            const token = getToken();
            if (!token) {
                console.warn("🚨 Token tidak ditemukan. Redirect ke login.");
                window.location.href = "/login";
                return;
            }

            try {
                const response = await axios.get(`${API_BASE_URL}/notifications/${username}`, {
                    headers: { "Authorization": token }
                });

                setNotifications(response.data);
                setUnreadCount(response.data.filter(n => !n.read).length);
            } catch (error) {
                console.error("❌ Gagal mengambil notifikasi:", error);
            }
        };

        fetchNotifications();
    }, [username]);

    // **Toggle Dropdown**
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    // **Tutup dropdown jika klik di luar**
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // **Tandai Semua Sebagai Dibaca**
    const markAllRead = async () => {
        const token = getToken();
        if (!token) {
            console.warn("🚨 Token tidak ditemukan.");
            return;
        }

        try {
            await axios.post(`${API_BASE_URL}/notifications/${username}/mark-read`, {}, {
                headers: { "Authorization": token }
            });

            // Update State setelah sukses
            setNotifications(notifications.map(n => ({ ...n, read: true })));
            setUnreadCount(0);
        } catch (error) {
            console.error("❌ Gagal menandai notifikasi sebagai dibaca:", error);
        }
    };

    return (
        <div className="nav-icon-container" ref={dropdownRef}>
            <button className="nav-icon-btn" onClick={toggleDropdown}>
                <Bell />
                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
            </button>

            {isOpen && (
                <div className="dropdown-menu notification-list">
                    <div className="notification-header">
                        <span>🔔 Notifikasi</span>
                        {notifications.length > 0 && (
                            <button onClick={markAllRead} className="mark-read-btn">✔ Mark All Read</button>
                        )}
                    </div>

                    <div className="notification-content">
                        {notifications.length === 0 ? (
                            <p className="notification-empty">Tidak ada notifikasi.</p>
                        ) : (
                            notifications.map((notif, index) => (
                                <div key={index} className={`notification-item ${notif.read ? "read" : ""}`}>
                                    <p>{notif.message}</p>
                                    <span className="notification-time">
                                        {new Date(notif.timestamp).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" })}
                                    </span>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Notification;